import { render, staticRenderFns } from "./HeadingWithIcon.vue?vue&type=template&id=3ae9a309"
import script from "./HeadingWithIcon.vue?vue&type=script&lang=js"
export * from "./HeadingWithIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports